export type Role = 'owner' | 'admin' | 'manager' | 'user';

export const ROLES: readonly Role[] = ['owner', 'admin', 'manager', 'user'];

const getRoleIndex = (role: Role) => {
  const roleIndex = ROLES.indexOf(role);

  return roleIndex;
};

export const getRolesCoveredBy = (role: Role): Role[] => {
  const roleIndex = getRoleIndex(role);

  return ROLES.slice(roleIndex);
};

export const hasRoleHigherThan = (userRole: Role, thanRole: Role): boolean => {
  const userRoleIndex = getRoleIndex(userRole);
  const thanRoleIndex = getRoleIndex(thanRole);

  return userRoleIndex < thanRoleIndex;
};
